import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {TicketingPriceBreakdownPanelProps} from '@Components/panels/ticketing-price-breakdown-panel/ticketing-price-breakdown-panel.types';

/**
 * Opens the price-breakdown modal. With no props it shows the wizard's per-ticket price breakdown; pass
 * `earningsStats` to show the dashboard's earnings breakdown instead (same panel, two modes).
 */
export const openTicketingPriceBreakdownModal = (props: TicketingPriceBreakdownPanelProps = {}): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.TICKETING_PRICE_BREAKDOWN_MODAL,
      panelProps: props,
    })
  );
};
